import { SET_RECORDS, RETRIEVE_RECORDS_STARTED } from '../actions/search';

export default function (state = {}, action) {
  switch (action.type) {
  case SET_RECORDS: {
    const { webhookEvents, meta } = action;
    return { ...state, isFetching: false, webhookEvents, meta };
  }
  case RETRIEVE_RECORDS_STARTED: {
    const changes = { isFetching: true };
    if (action.abortController) changes.abortController = action.abortController;

    return { ...state, ...changes };
  }
  default:
    return state;
  }
}
